module.exports = __webpack_public_path__ + "img/cacealma.8b61b6d1.jpg";